import {
  Component,
  Input,
  Output,
  EventEmitter,
  Renderer2,
  ViewChild,
  ElementRef
} from '@angular/core';
import * as Sugar from 'sugar';

@Component({
  selector: 'pregunta-crea',
  templateUrl: 'pregunta-crea.html'
})
export class PreguntaCreaComponent {

  @Input() preguntaActual: any;
  @Input() respuestaActual: any;
  @Input() enEsperaRespuesta: boolean;
  @Output() handleRespuesta = new EventEmitter<any>();
  @ViewChild('line1') line1: ElementRef;
  @ViewChild('line2') line2: ElementRef;
  @ViewChild('line3') line3: ElementRef;
  lineaActual: number;

  respuesta: Array<any>;

  seleccionUsuario: Array<any>;

  constructor(private renderer: Renderer2) {
    let respuesta = 'Esta es una respuesta en varios pedacitos y es algo larga';
    let respuestaArray = respuesta.split(' ').filter( c => c).map( (c, i) => ({index: i, text: c}));
    this.respuesta = Sugar.Array.shuffle(respuestaArray);

    this.lineaActual = 1;
    this.seleccionUsuario = [];
  }

  handleChunk(event, chunk) {
    if(event.target.classList.contains('seleccionado')) return;

    event.target.classList.add('seleccionado');

    chunk.event = event;

    this.agregaPalabra(chunk);
    this.limpiaLineas();
    this.dibujaPalabras();
  }

  limpiaLineas() {
    this.line1.nativeElement.innerHTML = '';
    this.line2.nativeElement.innerHTML = '';
    this.line3.nativeElement.innerHTML = '';
  }

  dibujaPalabras() {
    const widthLine = this.line1.nativeElement.offsetWidth;

    let lineaActual = 1;
    for (let palabra of this.seleccionUsuario) {
      const div: HTMLDivElement = this.renderer.createElement('div');
      div.innerHTML = palabra.text;
      div.classList.add('response-option');
      // div.style.visibility = 'hidden';

      if(lineaActual === 1) {
        this.renderer.appendChild(this.line1.nativeElement, div);
        let totalAnchoLine1 = this.getWidthLine(this.line1.nativeElement.children);

        if(totalAnchoLine1 >= widthLine ) {
          this.renderer.removeChild(this.line1.nativeElement, div)
          this.renderer.appendChild(this.line2.nativeElement, div);
          lineaActual = 2;
        }
      } else if(lineaActual === 2) {
        this.renderer.appendChild(this.line2.nativeElement, div);
        let totalAnchoLine2 = this.getWidthLine(this.line2.nativeElement.children);
        if(totalAnchoLine2 >= widthLine ) {
          this.renderer.removeChild(this.line2.nativeElement, div)
          this.renderer.appendChild(this.line3.nativeElement, div);
          lineaActual = 3;
        }
      } else if(lineaActual === 3 ) {
        this.renderer.appendChild(this.line3.nativeElement, div);
      }

      // div.style.visibility = '';

      this.agregaEventoPalabra(div, palabra);
    }
  }

  agregaEventoPalabra(div, palabra) {
    div.addEventListener('click', (e) => {
      palabra.event.target.classList.remove('seleccionado');

      this.borraPalabra(palabra);
      this.limpiaLineas();
      this.dibujaPalabras();
    });
  }

  agregaPalabra(palabra) {
    this.seleccionUsuario.push(palabra);
  }

  borraPalabra(palabra) {
    this.seleccionUsuario = this.seleccionUsuario.filter( p => p.index !== palabra.index);
  }

  getWidthLine(nodeChildren) {
    let children = nodeChildren;

    let totalAncho = 0;
    for (let i = 0; i < children.length; i++) {
      totalAncho += children[i].offsetWidth + 8;
    }

    return totalAncho;
  }

  _handleRespuesta(opcion, index) {


    this.handleRespuesta.emit({opcion, index});
  }
}



// WEBPACK FOOTER //
// ./src/components/pregunta-crea/pregunta-crea.ts